export default {
    title: "Uloge i korisnici",
    tabs: {
        roles: "Uloge",
        users: "Korisnici",
        invitations: "Pozivnice"
    },
    invitations: {
        swalText: "Vaša pozivnica će biti otkazana.",
        table: {
            status: "Status"
        },
        paginatorText: 'pozivnice(a)'
    },
    roles: {
        addRole: "Kreiraj ulogu",
        search: "Pretraži uloge",
        table: {
            name: "Naziv uloge",
            timesAssociated: "Broj ljudi",
            permissions: "Dozvole"
        },
        fullAccess: 'Sve dozvole',
        paginatorText: 'uloge(a)'
    },
    users: {
        addUser: "Dodaj korisnika",
        search: "Pretraži email",
        table: {
            firstName: "Ime",
            lastName: "Prezime",
            email: "Email",
            roles: "Uloge"
        },
        paginatorText: 'korisnika'
    },
    createUser: {
        title: "Pošalji pozivnicu",
        fields: {
            email: {
                label: "Email",
                placeholder: "Dodaj korinikov email",
            },
            firstName: {
                label: "Ime",
                placeholder: "Dodaj korisnikovo ime",
            },
            lastName: {
                label: "Prezime",
                placeholder: "Dodaj korisnikovo prezime",
            },
            role: {
                label: "Uloga",
                placeholder: "Pretraži uloge",
            }
        },
        button: {
            create: "Pošalji pozivnicu",
            cancel: "Poništi",
        },
        successMessage: 'Pozivnica je uspješno poslata!'
    },
    acceptInvitation: {
        title: "Izmijeni profil",
        fields: {
            firstName: {
                label: "Ime",
                placeholder: "Dodaj svoje ime",
            },
            lastName: {
                label: "Prezime",
                placeholder: "Dodaj svoje prezime",
            },
            password: {
                label: "Lozinka",
                placeholder: "Postavite svoju lozinku",
            }
        },
        button: {
            update: "Izmijeni profil i prihvati pozivnicu",
        },
        successMessage: 'Pozivnica je uspješno prihvaćena!',
        errorMessage: 'Neispravna pozivnica.'
    },
    saveRole: {
        createTitle: "Dodaj ulogu",
        updateTitle: "Izmijeni ulogu",
        backToLink: {
            text: "Nazad na",
            section: "uloge i korisnike"
        },
        fields: {
            name: {
                label: "Naziv uloge",
                placeholder: "Dodaj naziv uloge",
            },
            permissions: {
                label: "Dozvole",
                placeholder: "Dodaj dozvole",
            },
        },
        button: {
            create: "Kreiraj ulogu",
            update: "Sačuvaj",
            cancel: "Poništi",
        },
        successMessage: 'Uloga je uspješno sačuvana!'
    },
    saveUser: {
        updateTitle: "Izmijeni korisnika",
        backToLink: {
            text: "Nazad na",
            section: "uloge i korisnike"
        },
        fields: {
            roles: {
                label: "Uloge",
                placeholder: "Dodaj uloge",
            },
        },
        button: {
            update: "Sačuvaj",
            cancel: "Poništi",
        },
        successMessage: 'Korisnikove uloge su uspješno sačuvane!'
    }
}
